import { createPrefixedActions } from '@zapier/toolbox-redux-framework';

export default createPrefixedActions(
  'account',
  `
    CONFIRM_EMAIL

    ADD_ACCOUNT_BANNER
    ACKNOWLEDGE_ACCOUNT_BANNER

    LOAD_ACCOUNT_NOTIFICATIONS_DONE

    SET_ACCOUNT_SUMMARY_SCHEDULE
    SET_ACCOUNT_SUMMARY_SCHEDULE_DONE

    SET_ACCOUNT_TRIGGER_ALERTS
    SET_ACCOUNT_TRIGGER_ALERTS_DONE

    SET_ACCOUNT_ACTION_ALERTS
    SET_ACCOUNT_ACTION_ALERTS_DONE

    ADD_ACCOUNT_BANNER_NOTIFICATIONS_ERROR

    LOAD_ACCOUNT_SUBSCRIPTIONS_DONE

    ADD_ACCOUNT_SUBSCRIPTIONS
    ADD_ACCOUNT_SUBSCRIPTIONS_DONE
    ADD_ACCOUNT_SUBSCRIPTIONS_FAIL

    REMOVE_ACCOUNT_SUBSCRIPTIONS
    REMOVE_ACCOUNT_SUBSCRIPTIONS_DONE
    REMOVE_ACCOUNT_SUBSCRIPTIONS_FAIL

    SET_HAS_SEEN_NOTIFICATION
    SET_HAS_SEEN_NOTIFICATION_DONE
    SET_HAS_SEEN_NOTIFICATION_FAIL

    DECODE_MESSAGE
    DECODE_MESSAGE_DONE
  `
);
